const state = {
  isMobile: false,
  ui: localStorage['ui-mode'] || 'light',
  sidebarOpen: false,
  fontPreviewHasInput: false,
  contextSlotHidden: false
}

const mutations = {
  SET_IS_MOBILE(state, payload) {
    state.isMobile = payload;
  },
  SET_UI(state, payload) {
    state.ui = payload;
  },
  SET_CONTEXT_SLOT_STATE(state, payload) {
    state.contextSlotHidden = payload;
  },
  SET_FONT_PREVIEW_STATE(state, payload) {
    state.fontPreviewHasInput = payload;
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarOpen = !state.sidebarOpen;
  }
}

const actions = {
  setIsMobile({ commit }, payload) {
    commit('SET_IS_MOBILE', payload);
  },
  setUI({ commit }, payload) {
    commit('SET_UI', payload);
    localStorage['ui-mode'] = payload;
  },
  setContextSlotState({ commit }, payload) {
    commit('SET_CONTEXT_SLOT_STATE', payload);
  },
  setFontPreviewState({ commit }, payload) {
    commit('SET_FONT_PREVIEW_STATE', payload);
  },
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}